export function AuthWordmark(): JSX.Element {
  return (
    <div className="auth-wordmark" aria-label="WerkOS">
      <span style={{ color: 'var(--color-accent)' }}>werk</span>
      <span style={{ color: 'var(--color-muted)' }}>OS</span>
    </div>
  );
}
